/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { IAuthInputMethod } from '@models/IAuthInput'

export const isFormValid = (step: IAuthInputMethod, data: object) => {
  const inputIds = step.fields.map((f) => f.id)
  const values = Object.values(data)
  return inputIds.every((id) => id in data) && !values.includes(null)
}
